/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';

import { getLoginPathWithRedirect } from '../../shared/utilities/common';

const ProtectedRoute = ({
  component: Component,
  userToken,
  ...routeProps
}) => (
  <Route
    {...routeProps}
    render={({ location, ...routeRenderProps }) => {
      if (!userToken) {
        const redirectPath = `${location.pathname}${location.search || ''}`;
        return <Redirect to={getLoginPathWithRedirect(redirectPath)} />;
      }

      return <Component {...routeRenderProps} location={location} />;
    }}
  />
);

ProtectedRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  userToken: PropTypes.string,
};

ProtectedRoute.defaultProps = {
  userToken: null,
};

export const mapStateToProps = state => ({
  userToken: state.user.userToken,
});

export default connect(mapStateToProps)(ProtectedRoute);
